export default __webpack_public_path__ + "static/sp-checkbox-5bd51adbd84339861a1a0839c4f31756.png";